<template>
  <div class="download_index">
    <p class="no_content" v-if="list.length === 0">暂无内容</p>
    <ul v-if="list.length > 0">
      <li v-for="item in list" :key="item.id">
        <img src="./images/file_icon.png" />
        <span class="list_title">{{ item.name }}</span>
        <span class="list_type">{{ item.typeName }}</span>
        <span class="list_size">{{ item.sizeString }}</span>
        <span class="list_btn pointer" @click="onDownLoad(item.id)">下载</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'equip',
  components: {},
  data () {
    return {
      list: []
    }
  },
  created () {},
  mounted () {
    this.loaddData()
  },
  computed: {},
  methods: {
    loaddData () {
      this.$axios.downloadList().then(res => {
        if (res) {
          this.list = res.data.data
        }
      })
    },
    onDownLoad (itemId) {
      window.location.href = window.location.protocol + '//' + window.location.host + this.$axios.downloadFile(itemId)
    }
  },
  watch: {}
}
</script>

<style scoped>
  .download_index {width: 100%;height: 850px;background-color: #FFFFFF;border-radius: 5px;padding: 30px 50px;margin: 0 auto;border: 1px solid #dcdfe6;}
  .download_index ul {width: 100%;height: 100%;overflow: auto;}
  .download_index ul li {overflow: hidden;padding: 20px 0;border-bottom: 1px dashed #B8BFC8;}
  .download_index ul li img {width: 50px;margin-right: 10px;float: left;}
  .download_index ul li .list_title {float: left;width: 370px;height: 36px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;font-size: 14px;font-weight: 600;color: #333333;line-height: 18px;margin-top: 7px;margin-right: 40px;}
  .download_index ul li .list_type {display: block;width: 36px;height: 16px;border-radius:2px;font-size: 12px;color: #FFFFFF;line-height: 12px;background-color: #76BF28;float: left;text-align: center;line-height: 16px;margin-right: 10px;margin-top: 17px;}
  .list_size {font-size: 12px;color: #D6D6D6;line-height: 12px;float: left;margin-top: 19px;}
  .list_btn {font-size: 12px;font-weight: 600;line-height: 12px;color: #999999;float: right;margin-top: 19px;}
  .list_btn:hover {color: #76BF28;}
</style>



// WEBPACK FOOTER //
// src/pages/download/index.vue